module.exports = require("@nestjs/mapped-types");